<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 15:00:45
 * @LastEditTime: 2020-06-13 09:30:03
 * @Description: 数据内容区
 -->
<template>
  <div class="data-content">
    <data-table
      :filter-menu="filterMenu"
      :content="contentData.tableData"
      @reset-index-repull-list="resetIndexRepullListHandler" @repull-list="repullListHandler" />
    <data-page
      :total="contentData.total"
      :page="contentData.page" @index-change="pageIndexChanged" />
  </div>
</template>

<script>
import DataTable from './DataTable.vue';
import DataPage from './DataPage.vue';

export default {
  name: 'DataContent',
  components: {
    DataTable,
    DataPage,
  },
  props: {
    filterMenu: { type: Object, required: true },
    contentData: { type: Object, reuqired: true },
  },
  methods: {
    /**
     * 分页索引改变
     */
    pageIndexChanged(index) {
      this.$emit('index-change', index);
    },
    /**
     * 初始化page.index为首页并请求题库列表
     */
    resetIndexRepullListHandler() {
      this.$emit('reset-index-repull-list');
    },
    /**
     * 重新请求列表
     */
    repullListHandler() {
      this.$emit('repull-list');
    },
  },
};
</script>

<style lang="less" scoped>
.data-content {
  width: 100%;
}
</style>
